var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('page-loader',{attrs:{"loading":_vm.fetching}},[_vm._v(" sss ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }